import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pwa/img_bg.jpg")